import Axios from "../config/Axios";

export const ApiCrearTicket = async (data) => {
  try {
    const result = await Axios.post(`/POSTcreateTicket`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiUpdateTicket = async (pre_ticket_id, data) => {
  try {
    const result = await Axios.post(`/POSTupdateTicket/${pre_ticket_id}`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiDesactivarTicket = async (pre_ticket_id) => {
  try {
    const result = await Axios.post(`/POSTDesactivarTicket/${pre_ticket_id}`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiEstadoTicket = async (data) => {
  try {
    const result = await Axios.post(`/POSTtoggleEstadoTicket`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetAllTickets = async (data) => {
  try {
    const result = await Axios.get(`/GETallTickets`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetAllPedidosByFecha = async (fecha) => {
  try {
    const result = await Axios.get(`/GETallPedidosByFecha/${fecha}`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetDataTicket = async (pre_ticket_id) => {
  try {
    const result = await Axios.get(`/GETdataTicket/${pre_ticket_id}`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetTotalTicketWithDates = async (
  fecha_inicio,
  fecha_fin,
  filters = {}
) => {
  try {
    const result = await Axios.get(`/GETTtotalTicketsWithDate`, {
      params: {
        fecha_fin,
        fecha_inicio,
        search: filters.search || undefined,
        code: filters.code || undefined,
        comida: filters.comida || undefined,
        periodo: filters.periodo || undefined,
      },
    });
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetTotalTicketWithDatesByTipoAndComida = async (
  fecha_inicio,
  fecha_fin,
  tipo
) => {
  try {
    const result = await Axios.get(`/GETTtotalTicketsWithDateByTipoAndComida`, {
      params: {
        fecha_fin,
        fecha_inicio,
        tipo,
      },
    });
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetTotalTicketWithDatesComidas = async (
  fecha_inicio,
  fecha_fin,
  tipo,
  estado
) => {
  try {
    const result = await Axios.get(`/GETTtotalTicketsWithDateComida`, {
      params: {
        fecha_fin,
        fecha_inicio,
        tipo,
        estado,
      },
    });
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetAllTicketsWithDate = async (
  fecha_inicio,
  fecha_fin,
  page,
  pageSize,
  total,
  totalPaginasOrFilters,
  maybeFilters
) => {
  try {
    const filters =
      totalPaginasOrFilters && typeof totalPaginasOrFilters === "object"
        ? totalPaginasOrFilters
        : maybeFilters || {};
    const totalPaginas =
      typeof totalPaginasOrFilters === "number" ||
      typeof totalPaginasOrFilters === "string"
        ? totalPaginasOrFilters
        : undefined;

    const result = await Axios.get(`/GETallTicketsWithDate`, {
      params: {
        fecha_fin,
        fecha_inicio,
        pageSize,
        page,
        total,
        totalPaginas,
        search: filters.search || undefined,
        code: filters.code || undefined,
        comida: filters.comida || undefined,
        periodo: filters.periodo || undefined,
      },
    });
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetAllTicketsWithDateComidas = async (
  fecha_inicio,
  fecha_fin,
  page,
  pageSize,
  total,
  total_paginas,
  tipo,
  estado
) => {
  try {
    const result = await Axios.get(`/GETTicketsWithDateComida`, {
      params: {
        fecha_fin,
        fecha_inicio,
        pageSize,
        page,
        total,
        total_paginas,
        tipo,
        estado,
      },
    });
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};
export const ApiGetAllTicketsWithDatePage = async (
  fecha_inicio,
  fecha_fin,
  page,
  pageSize,
  total
) => {
  try {
    const result = await Axios.get(`/GETallTicketsWithDate`, {
      params: {
        fecha_fin,
        fecha_inicio,
        pageSize,
        page,
        total,
      },
    });
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};
